export function Panic({onPanic}) {
  return <section>
    <h2>Where is Everyone?</h2>
    <a href="https://www.messenger.com/t/2221464107924874" target="_blank" rel="noreferrer"  onClick={() => onPanic()}><button>🚨 PANIC!!! 🚨</button></a>
  </section>;
}